<template>
  <section id="feed" ref="feedContent">
    <PageTitle :title="$t('blog.feed.title')" :breadcrumbs="breadcrumbs"></PageTitle>
    
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <div class="row" v-if="selectedFeed">
        <div class="col">
          <ListPosts></ListPosts>
        </div>
      </div>

    </div>
  </section>
</template>


<script lang="ts">
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useFeedAdmin } from '../../composables/useFeedAdmin';

import Header from '../panels/Header.vue';

import ListPosts from '../panels/posts/ListPosts.vue';

@Component({
  components: {
    PageTitle,
    ListPosts,
    Header
  }
})
export default class Feed extends mixins(GenericPage) {

  setup(props:any, context:any) {
    const { feeds, selectedFeed } = useFeedAdmin(props, context);
    return { feeds, selectedFeed }
  }

  get breadcrumbs() {
    return [{
      label: this.$t('home.dashboard')
    },
    {
      label: this.$t('blog.title')
    }]
  }

  mounted() {
    enableIbox(this.$refs.feedContent as HTMLElement);
  }

  beforeDestroy() {
    disableIbox(this.$refs.feedContent as HTMLElement);
  }

}
</script>